module.exports = __webpack_public_path__ + "img/clubicon-soccer.41c6aa7e.png";